/* istanbul ignore file */
export { default } from './ErrorDisplay';
